import WINDOW from "../../../../utils/window";

/**
 *
 * @param {BoundsProps} bounds
 * @returns {Map<"x" | "y", Number>}
 */
const getCenter = (bounds) => {
  const store = new Map();
  const scroll = /** @type {WindowCoordinatesProps} */ (WINDOW.get("scroll"));
  const scrollX = /** @type {Number} */ (scroll.get("x"));
  const scrollY = /** @type {Number} */ (scroll.get("y"));

  const middleX = /** @type {Number} */ (bounds.get("middle-x"));
  const middleY = /** @type {Number} */ (bounds.get("middle-y"));

  const x = middleX - scrollX;
  const y = middleY - scrollY;

  bounds.set("center-x", x);
  bounds.set("center-y", y);

  return new Map([["x", x], ["y", y]]);
};

export default getCenter;
